import React from 'react';
import { Crosshair } from 'lucide-react';

export default function AuditHero() {
  return (
    <section className="pt-16 pb-10 text-center">
      {/* Badge */}
      <div className="inline-flex items-center gap-2 bg-primary/10 border border-primary/20 text-primary text-xs font-medium font-mono px-3 py-1.5 rounded-full mb-6">
        <Crosshair size={12} />
        Conversion Friction Detector
      </div>

      {/* Headline */}
      <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-foreground leading-[1.1] mb-4">
        Why aren&apos;t visitors{' '}
        <span
          style={{
            background: 'linear-gradient(135deg, #FF3D57 0%, #FF8C3D 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}
        >
          converting?
        </span>
      </h1>

      <p className="text-muted-foreground text-lg sm:text-xl max-w-2xl mx-auto leading-relaxed">
        Paste your SaaS landing page URL. FrictionScan checks 10 conversion signals in seconds and tells you exactly what to fix.
      </p>
    </section>
  );
}